"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageSelect = void 0;
const ac_1 = require("@app/ac");
const ui_1 = require("@app/component/ui");
const dropdown_input_1 = require("@app/component/ui/forms/dropdown-input/dropdown-input");
const const_1 = require("@app/const");
const request_1 = require("@app/request");
const store_1 = require("@app/store");
const util_1 = require("@app/util");
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const LanguageSelect = () => {
    const dispatch = (0, store_1.useRootDispatch)();
    const languages = const_1.config.supportedLanguages;
    const userId = (0, store_1.useRootSelector)((state) => state.me).id;
    const locale = (0, store_1.useRootSelector)((state) => state.locale);
    const { control, handleSubmit } = (0, react_hook_form_1.useForm)({
        defaultValues: {
            language: locale,
        },
    });
    const onSubmit = handleSubmit(async (data) => {
        await (0, request_1.requestUserUpdate)({
            id: userId,
            data: {
                language: data.language,
            },
        });
        await dispatch((0, ac_1.setLocale)(data.language));
        await dispatch((0, ac_1.setModal)(null));
    });
    return (react_1.default.createElement(ui_1.Modal, { size: ui_1.Modal.SIZES.S, headerContent: react_1.default.createElement("div", { style: { display: 'flex', justifyContent: 'space-between' } },
            react_1.default.createElement(ui_1.Text, { text: (0, util_1.t)('ACC_SET_SELECT_LANGUAGE'), type: ui_1.Text.TYPES.BODY_LARGE, weight: ui_1.Text.WEIGHTS.BOLD })), footerContent: react_1.default.createElement("div", { style: { display: 'flex', justifyContent: 'end', width: '100%' } },
            react_1.default.createElement(ui_1.Button, { onClick: () => {
                    void dispatch((0, ac_1.setModal)(null));
                } }, (0, util_1.t)('CLOSE')),
            react_1.default.createElement(ui_1.Button, { style: 'CONTAINED', onClick: onSubmit }, (0, util_1.t)('SAVE'))) },
        react_1.default.createElement(ui_1.Spacing, { size: ui_1.Spacing.SIZES.SIZE_16, type: ui_1.Spacing.TYPES.BOTH },
            react_1.default.createElement(dropdown_input_1.DropdownInput, { label: (0, util_1.t)('ACC_SET_SELECT_LANGUAGE'), placeholder: (0, util_1.t)('ACC_SET_SELECT_LANGUAGE'), control: control, options: languages, name: 'language' }))));
};
exports.LanguageSelect = LanguageSelect;
